import i18n from "@/i18n.ts";
import { ApiConferenceProviders } from "@/types/calendar.types.ts";
import { ApiEventVisibility } from "@/types/event.types.ts";
import { Rule } from "@/types/rule.types.ts";
import { z } from "zod";

export const buildEventSchema = () => {
  const required = i18n.t("errors:field_required");

  return z
    .object({
      title: z.string({ error: required }).min(1, required),
      timezone: z.string().optional(),
      description: z.string().optional(),
      visibility: z.enum(ApiEventVisibility).optional(),
      calendar_id: z.number({ error: required }),
      conference_provider: z.enum(ApiConferenceProviders).nullable().optional(),
      datetime_start: z.date({ error: required }),
      datetime_end: z.date({ error: required }),
      is_all_day: z.boolean({ error: required }),
      attendee_rule_groups: z.array(z.object({ rules: z.array(z.custom<Rule>()) })).optional(),
    })
    .superRefine((data, ctx) => {
      if (!data.is_all_day && data.datetime_end <= data.datetime_start) {
        ctx.addIssue({
          code: "custom",
          message: i18n.t("errors:end_date_should_be_greater_start_date"),
          path: ["datetime_end"],
        });
      }
    });
};

export type EventSchema = z.infer<ReturnType<typeof buildEventSchema>>;
